







































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  nextTick,
} from '@vue/composition-api';
import * as echarts from 'echarts';
import { Message } from 'element-ui';
import QRCode from 'qrcodejs2';

import valueToLabel from '@utils/valueToLabel';
import svgCom from '@components/Svg/index';
import request from '@utils/request';
import { userInfor as userInfoRef } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'DataFinancingApply',
  components: {
    svgCom,
    QRCode,
  },
  setup() {
    const state = reactive({
      checkedBank: '',
      socialCreditCode: '',
      scoreUpdateTime: '',
      dataList: [],
      dialogVisible: false,
      dialogMsg: '',
      dialogType: '',
      financingUrl: '',
      qrcode: null,
      applyInfos: [
        {
          bankCode: 'CMB',
          bizStatus: '',
          loginUrl: '',
          processMsg: '',
        },
        {
          bankCode: 'CCB',
          bizStatus: '',
          loginUrl: '',
          processMsg: '',
        },
      ],
    });
    const option = {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 1000,
          progress: {
            show: true,
            width: 0,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#A3FB7C', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#ED4838', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          axisLine: {
            lineStyle: {
              width: 0,
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            distance: 36,
            length: 8,
            lineStyle: {
              width: 2,
              color: '#999',
            },
          },
          axisLabel: {
            distance: 5,
            color: '#999',
            fontSize: 14,
            formatter: function (v) {
              // 只显示数字0和1000
              if (v === 0) {
                return '0';
              } else if (v === 1000) {
                return '1000';
              }
            },
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 10,
            itemStyle: {
              borderWidth: 2,
            },
          },
          pointer: {
            show: true,
            width: 10,
            itemStyle: {
              color: '#000',
            },
          },

          title: {
            offsetCenter: [0, '80%'],
            fontSize: 13,
          },
          detail: {
            valueAnimation: true,
            fontSize: 30,
            offsetCenter: [0, '60%'],
            color: '#FF5C5C',
          },
          data: [
            {
              value: '0',
              name: '企业合作分',
            },
          ],
        },
      ],
    };

    // 页面初始化
    const init = async () => {
      const params = {
        vendorName: userInfor.supplierName,
        current: 1,
        pageSize: 10,
      };
      const res = await request('dataFinancing', 'getScoreList', params);
      if (res.code === 2000) {
        state.dataList = res.data.dataList && res.data.dataList[0];
        state.applyInfos = state.applyInfos.map(itemA=> {
          const itemB = (state.dataList as any).applyInfos.find(b=>b.bankCode === itemA.bankCode);
          return itemB ? itemB : itemA;
        })
        option.series[0].data[0].value =
          (state.dataList as any).totalScore || 0;
        state.scoreUpdateTime = (state.dataList as any).dataDate;
        state.socialCreditCode = (state.dataList as any).socialCreditCode;
      }
      nextTick(() => {
        initChart();
      });
    };

    // 图表初始化
    const initChart = () => {
      const chartDom: any = document.getElementById('gauge-chart');
      console.log('chartDom:', chartDom);

      const myChart = echarts.init(chartDom);
      option && myChart.setOption(option);
    };

    const createQrcode = (it) => {
      if (it.loginUrl && it.bankCode === 'CMB') {
        setTimeout(() => {
          const qrcodeDom: any = document.getElementById('qrcode');
          if (state.qrcode && qrcodeDom) {
            qrcodeDom.innerHTML = '';
          }
          state.qrcode = new QRCode(qrcodeDom, {
            width: 70,
            height: 70,
            text: it.loginUrl,
          });
        }, 200);
      }
    };

    // 切换银行
    // const toggleCard = (index: number) => {
    //   option.series[0].data[0].value =
    //     (state.dataList[index] as any).totalScore || 0;
    //   state.scoreUpdateTime = (state.dataList[index] as any).dataDate;
    //   initChart();
    // };

    // 前往申请
    const applySubmit = async () => {
      if (typeof state.checkedBank !== 'number') {
        Message.error('请选择银行');
        return;
      }
      const res = await request('dataFinancing', 'financeInterfaceApply', {
        socialCreditCode: (state.dataList as any).socialCreditCode,
        bankCode: (state.applyInfos[state.checkedBank] as any)
          .bankCode,
      });
      if (res.code === 2000) {
        state.dialogVisible = true;
        state.dialogType = 'apply';
        state.dialogMsg =
          '银行侧进行供应商数据融资评估约几分钟，评估通过后可点击“前往融资”按钮申请融资～';
      }
    };
    const toUrl = (url) => {
      state.dialogVisible = true;
      state.financingUrl = url;
      state.dialogType = 'financing';
      state.dialogMsg =
        '页面即将跳转至第三方银行服务平台，腾讯公司不会对该平台上的个人信息进行处理。本平台仅提供技术服务，具体融资服务均由第三方银行提供，融资服务的合法性、真实性、准确性均由第三方银行负责，请您基于第三方银行提供的信息审慎判断并选择是否在银行开通融资信贷服务。';
    };
    const dialogConfirm = (type) => {
      if (type === 'apply') {
        state.dialogVisible = false;
        state.dialogType = '';
        state.dialogMsg = '';
      } else if (type === 'financing') {
        state.dialogVisible = false;
        state.dialogType = '';
        state.dialogMsg = '';
        window.open(state.financingUrl);
      }
    };
    onMounted(init);
    return {
      ...toRefs(state),
      userInfor,
      applySubmit,
      toUrl,
      valueToLabel,
      dialogConfirm,
      createQrcode,
    };
  },
});
